/**
 * SINGLE SOURCE OF TRUTH for the app navigation.
 *
 * To add a new page to the sidebar:
 *   1. Add an entry here (icon, label, path, category).
 *   2. Add the route + ProtectedRoute in App.js.
 *   That's it — the sidebar updates automatically everywhere.
 *
 * NOTE: `icon` is a react-icons component (outline/stroke style), NOT a string.
 * Every render site must use it as `const Icon = item.icon; <Icon />`.
 */

import {
  FiTrendingUp, FiMonitor, FiSearch, FiGrid, FiStar, FiCalendar,
  FiTarget, FiCompass, FiBookOpen, FiPieChart, FiSun, FiClock, FiMoon,
  FiRotateCw, FiClipboard, FiDownloadCloud, FiPackage, FiSettings, FiUsers,
  FiUpload, FiActivity, FiLink, FiDatabase, FiFileText, FiEdit3, FiEye,
  FiLayers,
} from 'react-icons/fi';

export const NAV_SECTIONS = [
  {
    category: 'Market',
    items: [
      { path: '/market-insight', icon: FiTrendingUp, label: 'Market Insight' },
      { path: '/stock-insight',   icon: FiMonitor, label: 'Stock Insight' },
      { path: '/stock-summary', icon: FiSearch, label: 'Stock Intelligence' },
      { path: '/heatmap',       icon: FiGrid, label: 'Heat Map' },
      { path: '/daily-snapshot', icon: FiStar, label: 'Daily Snapshot' },
      { path: '/cs-calendar',   icon: FiCalendar, label: 'CS Calendar' },
      { path: '/cas-calendar',  icon: FiClock, label: 'CAS Calendar' },
      { path: '/combined-calendar', icon: FiLayers, label: 'Combined Calendar' },
      { path: '/market-screener', icon: FiTarget, label: 'Market Screener' },
    ],
  },
  {
    category: 'Strategy',
    items: [
      { path: '/strategy-radar', icon: FiCompass, label: 'Strategy Radar' },
    ],
  },
  {
    category: 'Analysis',
    items: [
      { path: '/research-desk', icon: FiBookOpen, label: 'Research Desk' },
    ],
  },
  {
    category: 'Sectors',
    items: [
      { path: '/sector-radar', icon: FiPieChart, label: 'Sector Radar' },
      { path: '/sector-calendar',    icon: FiLayers, label: 'Sector Calendar' },
    ],
  },
  {
    category: 'Financial Astrology',
    items: [
      { path: '/astro-insight',   icon: FiSun, label: 'Astro Insight' },
      { path: '/nakshatra', icon: FiStar, label: 'Nakshatra' },
      { path: '/time-trend-shift', icon: FiClock, label: 'Time Trend Shift' },
      { path: '/astro-calendar',  icon: FiMoon, label: 'Astro Calendar' },
      { path: '/gann-reversal',  icon: FiRotateCw, label: 'Gann Reversal' },
    ],
  },
  {
    category: 'Watchlist',
    items: [
      { path: '/watchlist-manager', icon: FiClipboard, label: 'Watchlist Manager' },
      { path: '/watchlist-tracker', icon: FiEye, label: 'Watchlist Tracker' },
    ],
  },
  {
    category: 'Portfolio',
    items: [
      { path: '/model-portfolio', icon: FiPackage, label: 'Model Portfolios' },
    ],
  },
  {
    category: 'Admin',
    adminOnly: true,
    items: [
      { path: '/admin',                    icon: FiSettings,  label: 'Admin Dashboard' },
      { path: '/admin/users',              icon: FiUsers, label: 'User Management' },
      { path: '/admin/astro-calendar',     icon: FiMoon, label: 'Astro Calendar Admin' },
      { path: '/admin/watchlist-tracker',  icon: FiEye, label: 'User Watchlists' },
      { path: '/admin/batch-upload',       icon: FiUpload, label: 'Manual Batch Upload' },
      { path: '/admin/pre-open-market',       icon: FiTrendingUp, label: 'Fetch Market Data' },
      { path: '/admin/fetch-strategy-data',  icon: FiDownloadCloud, label: 'Fetch Strategy Data' },
      { path: '/admin/strategy-library',     icon: FiTarget, label: 'Strategy Library' },
      { path: '/admin/chartink-webhook',     icon: FiLink, label: 'Chartink Webhook' },
      { path: '/admin/db-management',        icon: FiDatabase, label: 'DB Management' },
      { path: '/admin/activity-logs',         icon: FiFileText, label: 'Activity Log' },
      { path: '/admin/user-monitor',          icon: FiActivity, label: 'User Monitor' },
      { path: '/admin/expert-view',           icon: FiEdit3, label: 'Expertview Admin' },
      { path: '/admin/model-portfolio',       icon: FiPackage, label: 'Model Portfolio Admin' },
    ],
  },
];
